import React, { useEffect } from 'react';
import { Link, RichText, Text, Image, Placeholder } from '@sitecore-jss/sitecore-jss-react';

const CategoryBanner = (props) => {
  const fields = props?.fields;

  useEffect(() => {
    var swiper = new Swiper('.topBenefits-slider', {
      slidesPerView: 4,
      spaceBetween: 40,
      freeMode: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10,
          slidesOffsetBefore: 0,
        },
        768: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });
  }, []);

  return (
    <>
      <section className="top_banner_wrapper top_banner_wrapper_cat">
        <div className="swiper_vs_wrapper">
          <div className="swiper-slide">
            {/* Desktop Picture */}
            <picture>
              <Image field={fields?.bgImage?.value} className="d-none d-md-block" loading="lazy" />
            </picture>

            {/* Mobile Picture */}
            <picture className="d-block d-md-none">
              {fields?.bgImageMobile?.value?.src ? (
                <img
                  src={fields?.bgImageMobile?.value?.src}
                  alt={fields?.bgImageMobile?.value?.alt}
                  width={fields?.bgImageMobile?.value?.width}
                  height={fields?.bgImageMobile?.value?.height}
                  loading="lazy"
                />
              ) : (
                <img
                  src={fields?.bgImage?.value?.src}
                  alt={fields?.bgImage?.value?.alt}
                  width={fields?.bgImage?.value?.width}
                  height={fields?.bgImage?.value?.height}
                  loading="lazy"
                />
              )}
            </picture>

            <div className="banner_caption_wrapper">
              <Placeholder name="breadcrumbs" rendering={props?.rendering} />
              <div className="caption_inner_wrap">
                <h1>
                  <span>
                    <RichText field={fields?.heading} editable />
                  </span>
                </h1>
                <p className="cat_banner_p">
                  <Text field={fields?.subheading} editable />
                </p>
                {fields?.benifits?.length > 0 && (
                  <ul className="cat_banner_ul">
                    {fields?.benifits.map((item) => (
                      <li className="cat_banner_item" key={item.id}>
                        <div className="iImage-ck">
                          <Image
                            className="iImg-ck--img"
                            field={item.fields.Icon}
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                        <div className="cat_item_span">
                          <div
                            className="cat_item_span"
                            dangerouslySetInnerHTML={{ __html: item.fields.Title.value }}
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
                <RichText tag="div" field={fields?.services} editable />
                {fields?.CTA && fields?.CTA?.value?.href && (
                  <Link className="know_more_about-us vs_banner_btn" field={fields.CTA} />
                )}
              </div>
            </div>
            {fields?.VideoCTA && fields?.VideoCTA?.value?.href && (
              <div className="banner_play_video">
                <a
                  href="#"
                  className="video-play-button"
                  id="play-video"
                  data-bs-toggle="modal"
                  data-bs-target="#video-modal"
                  data-src={fields.VideoCTA.value.href}
                >
                  <span className="play_ico">
                    <img
                      src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/category/watch_video.svg"
                      className="watch_video"
                      alt="watch video"
                    />
                  </span>
                  <div>
                    <p>
                      <Text field={fields?.VideoTitle} editable />
                    </p>
                    <span>
                      <Text field={fields?.VideoSubTitle} editable />
                    </span>
                  </div>
                </a>
              </div>
            )}
          </div>
        </div>

        <div
          className={`swiper_right_div category_right_div ${
            props?.rendering?.placeholders?.lead_form[0]?.params?.IsDigiGold === '1'
              ? 'digi_gold_right_form'
              : ''
          }`}
        >
          <div className="start_journey_main_Wrapper homepage-banner homepage-banner-xenter bg_img_for_lead_form_banner">
            <Placeholder name="lead_form" rendering={props?.rendering} />
          </div>
        </div>

        {fields?.overview?.value && (
          <RichText
            tag="div"
            className="banner_infograp_wrapper"
            field={fields?.overview}
            editable
          />
        )}
      </section>
      {fields?.VideoCTA?.value?.href && (
        <div
          className="modal fade video_modal_sec_2"
          id="video-modal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="video-modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div className="modal-body popup__overlay">
                <iframe
                  width="100%"
                  height="100%"
                  src=""
                  id="video"
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryBanner;
